<div class="flex h-full overflow-auto bg-black-dark border-t-3 border-darker-gray">
  <div class="flex flex-col gap-2 mt-4 primary-menu">
    @for (item of items(); track item) {
      <div class="flex items-center justify-center">
        <a [routerLink]="item.routerLink">
          <p-button 
            (click)="primaryMenuItemClick(item)"
            [styleClass]="getMenuButtonStyleClass(item)"
            [text]="true"
            [title]="item.title">
            
            @if (item.icon) {
              <img alt="logo" [src]="item.icon" class="sidepanel-icon" />
            }
            <span class="ml-2" i18n>{{showSecondaryMenu ?  '' : item.label}}</span>
          </p-button>
        </a>
      </div>
    }
  </div>
  @if (subitems && showSecondaryMenu) {
    <div class="flex flex-col secondary-menu border-l-3 border-darker-gray">
      <div class="pl-4 pt-1 pb-2">
        <div class="text-base text-muted-color font-bold mt-4">{{sectionName}}</div>
        <p-divider class="w-8"></p-divider>
      </div>
      <p-panel-menu [model]="subitems" [multiple]="true" ></p-panel-menu>
      <!-- for possible future content -->
      <!-- and helps with border between primary and secondary part of the menu -->
      <div class="flex flex-auto"></div>
    </div>
  }
</div>